export default import.meta.ROLLDOWN_FILE_URL_BjjUHagISQHtPWYmu3KuwQ_d8f06ef37e73715ccc4d951c